export default "__VITE_ASSET__DWbrLijf__"